// TODO: snackbars stack
// TODO: remove from vuex

export const UI_SET_SNACKBAR = 'UI_SET_SNACKBAR'

export const INFO = 'INFO'
export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'
export const WARNING = 'WARNING'

const state = {
    snackbar: {
        open: true,
        text: 'No text specified',
        duration: 6000,
        type: INFO, // INFO | ERROR | SUCCESS | WARNING,
        withClose: false
    }
}

const getters = {
    snackbar: state => state.snackbar
}

const mutations = {
    [UI_SET_SNACKBAR]: (state, data) => {
        state.snackbar = data
    }
}

const actions = {
    [UI_SET_SNACKBAR]({commit, getters}, payload) {
        let snackbar = {...getters.snackbar}
        snackbar.open = payload.open

        if (payload.text) {
            snackbar.text = payload.text
        } else {
            switch (payload.type) {
            case SUCCESS:
                snackbar.text = 'Success'
                break
            case ERROR:
                snackbar.text = 'Something went wrong'
                break
            case INFO:
                snackbar.text = 'Passed'
                break
            case WARNING:
                snackbar.text = 'Warning'
                break
            default:
                snackbar.text = 'No text specified'
            }
        }
        if (payload.type) {
            snackbar.type = payload.type
        }

        // If only error object passed
        if (payload.error) {
            snackbar.type = ERROR
            // Server error handling
            if (payload.error.response) {
                const res = payload.error.response
                snackbar.text = '( Server error ) '
                if (res.data && res.data.message) {
                    snackbar.text += res.data.message
                } else if (res.data) {
                    snackbar.text += res.data
                } else if (res) {
                    snackbar.text += res
                } else {
                    snackbar.text = 'Unknown'
                }
            } else if (payload.error.message) { // JS common errors
                snackbar.text = `${payload.error.name}: ${payload.error.message}`
            } else {
                snackbar.text = 'Unknown error'
            }
        }

        if (String(snackbar.text).length > 300) {
            snackbar.text = `${String(snackbar.text).substring(0, 300)} ...`
        }
        snackbar.caption = payload.caption
        snackbar.duration = payload.duration || 6000
        snackbar.withClose = !!payload.withClose
        commit(UI_SET_SNACKBAR, snackbar)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
